// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2YhTa","content":"ManualTimeModal_content__1zw3H"};